<template>
  <div class="flex flex-row ml-2 mr-2">
    <app-table v-bind="$attrs" class="table-auto w-full">
      <template v-slot:table-body>
        <tr
          :class="
            (header.attr === header.attr) === 'files' ? 'border-none' : ''
          "
          class="border border-collapse border-dashed border-green border-t-0 border-l-0 border-r-0 h-12"
          v-for="(header, index) in rejectHeaders"
          :key="'reject-headers' + index"
        >
          <!-- 差し戻し選択時の表示 -->
          <template v-if="rejected(header.attr)">
            <td width="185px" class="rejected-line">
              <div class="flex flex-row items-center cursor-pointer">
                <RejectedIcn width="20px" height="20px" class="ml-3 mr-1" />
                <span class="text-lg text-red font-bold">
                  {{ header.title }}
                </span>
                <LetterGreen
                  v-if="header.attr == 'officeMessage'"
                  class="pt-1 mr-2 ml-1 red-icon"
                  width="18px"
                  height="18px"
                ></LetterGreen>
              </div>
              <div
                class="flex flex-row items-center cursor-pointer mt-4"
                @click="rejectToggleAttr(header)"
              >
                <RejectCancelIcn class="ml-3 mr-1" />
                <div class="flex flex-row items-baseline">
                  <span class="text-lg text-red font-bold">
                    入力
                  </span>
                  <span class="text-sm text-red font-bold">
                    を
                  </span>
                  <span class="text-lg text-red font-bold">
                    解除
                  </span>
                </div>
              </div>
            </td>
            <td class="rejected-line pr-3 " style="height: 93px">
              <span
                class="text-lg text-red block mb-3"
                :id="`reason-comment-${header.attr}`"
                @click="showReasonInput(header.attr)"
                v-show="false"
              >
                {{
                  header.comment.length
                    ? header.comment
                    : '※ コメントはありません'
                }}
              </span>
              <!-- inputタグだと改行できないためofficeMessageはtextareaを使用する -->
              <textarea
                v-if="header.attr === 'officeMessage'"
                class="text-red border border-1 border-red resize-none px-4"
                style="width:642px;height: 120px; border-radius: 20px;margin: 10px 0px;"
                placeholder="メッセージを入力ください"
                v-model="header.comment"
                @blur="onBlur(header)"
                :id="`reason-input-${header.attr}`"
                v-show="true"
              ></textarea>
              <AppTextInput
                v-else
                color="red"
                class="text-red"
                style="width:642px"
                placeholder="コメントを入力ください"
                v-model="header.comment"
                @blur="onBlur(header)"
                :id="`reason-input-${header.attr}`"
                v-show="true"
              ></AppTextInput
              ><br />
              <!-- 経費項目 -->
              <span v-if="header.attr === 'expenseTypeId'" class="text-lg">
                <p>{{ currentReceipt['expenseTypeId'][0].name }}</p>
              </span>
              <!-- 按分がない場合の支出額 -->
              <span
                class="text-lg"
                v-else-if="
                  !currentReceipt.isDistributed &&
                    header.attr == 'expenseAmount'
                "
              >
                {{ currentReceipt['expenseAmount'].toLocaleString() }}円
              </span>
              <!-- 按分があった場合の支出額 -->
              <span
                class="text-lg"
                v-else-if="
                  currentReceipt.isDistributed && header.attr == 'expenseAmount'
                "
              >
                <span>
                  {{ prorateCalc() }}
                </span>
              </span>
              <!-- 支出年月日 -->
              <span v-else-if="header.attr == 'expenseDate'" class="text-lg">
                {{ $filters.dateFormat(currentReceipt['expenseDate']) }} |
                {{
                  $filters.wareki(
                    currentReceipt['expenseDate'].replace(/-/g, '/'),
                  )
                }}
              </span>
              <!-- 領収書添付 -->
              <span v-else-if="header.attr == 'files'" class="text-lg">
                <div
                  v-for="(img, index) in currentReceipt.images"
                  :key="'images' + index"
                >
                  <span :class="`text-red mb-1 ml-1`"
                    >※画像クリックで黒塗りダイアログが開きます</span
                  >
                  <img
                    v-if="img.normalImage"
                    :src="
                      img.blackImage == null ? img.normalImage : img.blackImage
                    "
                    @click="
                      openImgPreview('receipt', index, {
                        normalImage: img.normalImage,
                        blackImage: img.blackImage,
                      })
                    "
                  />
                </div>
              </span>
              <!-- その他 -->
              <span v-else>
                {{ currentReceipt[header.attr] }}
              </span>
            </td>
          </template>

          <!-- 差し戻し未選択時の表示 -->
          <template v-else>
            <td width="185px">
              <div
                class="flex flex-row items-center cursor-pointer"
                @click="rejectToggleAttr(header)"
              >
                <RejectIcn width="20px" height="20px" class="ml-3 mr-1" />
                <span class="text-lg text-green font-bold">
                  {{ header.title }}
                </span>
                <LetterGreen
                  v-if="header.attr == 'officeMessage'"
                  class="pt-1 mr-2 ml-1"
                  width="18px"
                  height="18px"
                ></LetterGreen>
              </div>
            </td>

            <td v-if="header.attr == 'expenseDate'" class="text-lg relative">
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_date')"
              />
              {{ $filters.dateFormat(currentReceipt['expenseDate']) }} |
              {{
                $filters.wareki(
                  currentReceipt['expenseDate'].replace(/-/g, '/'),
                )
              }}
            </td>
            <td
              v-else-if="
                !currentReceipt.isDistributed && header.attr == 'expenseAmount'
              "
              class="text-lg relative"
            >
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_amount')"
              />
              {{ currentReceipt['expenseAmount'].toLocaleString() }}円
            </td>
            <td
              v-else-if="
                currentReceipt.isDistributed && header.attr == 'expenseAmount'
              "
              class="text-lg relative"
            >
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_amount')"
              />
              <span>
                {{ prorateCalc() }}
              </span>
            </td>
            <td
              v-else-if="header.attr === 'expenseTypeId'"
              class="text-lg relative"
            >
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('expense_type_id')"
              />
              <span
                class="text-lg"
                v-for="(type, index) in currentReceipt.expenseTypeId"
                :key="'expense-type' + index"
              >
                <p>{{ type.name }}</p>
                <p v-if="addComma(index)">
                  ,
                </p>
              </span>
            </td>
            <td v-else-if="header.attr == 'files'" class="relative">
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('files')"
              />
              <span class="text-lg">
                <div
                  v-for="(img, index) in currentReceipt.images"
                  :key="'images' + index"
                >
                  <span :class="`text-red mb-1 ml-1`"
                    >※画像クリックで黒塗りダイアログが開きます</span
                  >
                  <img
                    v-if="img.normalImage"
                    :src="
                      img.blackImage == null ? img.normalImage : img.blackImage
                    "
                    @click="
                      openImgPreview('receipt', index, {
                        normalImage: img.normalImage,
                        blackImage: img.blackImage,
                      })
                    "
                  />
                </div>
                &nbsp;
              </span>
            </td>
            <td v-else-if="header.attr == 'officeMessage'" class="relative">
              <AppPreviewSentBackItem
                color="green"
                :message="getSentBackItemMessage('office_message')"
              />
              <span class="text-lg">
                {{ currentReceipt[header.attr] }}&nbsp;
              </span>
            </td>
            <td v-else class="relative">
              <AppPreviewSentBackItem
                color="green"
                :message="
                  getSentBackItemMessage(
                    header.attr
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase(),
                  )
                "
              />
              <span class="text-lg">
                {{ currentReceipt[header.attr] }}&nbsp;
              </span>
            </td>
          </template>
        </tr>
      </template>
    </app-table>
  </div>
</template>

<script>
import {
  nextTick,
  // onBeforeUnmount,
  reactive,
} from 'vue'
import AppTable from '@/components/ui/AppTable'
import AppTextInput from '@/components/ui/AppTextInput'
import AppPreviewSentBackItem from '@/components/ui/AppPreviewSentBackItem'
import RejectIcn from '@/assets/icons/reject.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import RejectCancelIcn from '@/assets/icons/reject-cancel.svg?inline'
import LetterGreen from '@/assets/icons/letter-green.svg?inline'
import { useReceiptReject } from '@/services/receipt/useReceiptReject'
import { useReceipts } from '@/services/receipt/useReceipts'
import { useReceiptForm } from '@/services/receipt/useReceiptForm'
import { useDialog } from '@/services/useDialog'

export default {
  name: 'ReceiptOffice',

  components: {
    AppTable,
    AppTextInput,
    AppPreviewSentBackItem,
    RejectIcn,
    RejectedIcn,
    RejectCancelIcn,
    LetterGreen,
  },

  setup() {
    let imgPreviewState = reactive({ isShown: false, previewImgSrc: null })
    let {
      rejectHeaders,
      rejectedAttrs,
      // resetRejectedItems,
    } = useReceiptReject()

    const { currentReceipt } = useReceipts()
    const { prorateCalc } = useReceiptForm()
    // onBeforeUnmount(() => {
    //   resetRejectedItems()
    // })

    const isShowImgPreview = src => {
      imgPreviewState.isShown = true
      imgPreviewState.previewImgSrc = src
    }

    const onBlur = header => {
      let comment = document.getElementById(`reason-comment-${header.attr}`)
      let reasonInput = document.getElementById(`reason-input-${header.attr}`)
      comment.style.display = 'block'
      reasonInput.style.display = 'none'
      header.comment = reasonInput.value
      rejectedAttrs.find(item => item.target == header.attr).comment =
        reasonInput.value
    }

    const rejectToggleAttr = header => {
      const itemIndex = rejectedAttrs.findIndex(
        item => item.target == header.attr,
      )

      if (itemIndex > -1) {
        rejectedAttrs.splice(itemIndex, 1)
        header.comment = ''
        // headers.find((item) => item.attr == attr).comment = "";
      } else {
        rejectedAttrs.push({
          target: header.attr,
          comment: '',
        })
        nextTick(() => {
          document.getElementById(`reason-input-${header.attr}`).focus()
        })
      }
    }

    const rejected = attr => {
      return rejectedAttrs.findIndex(item => item.target == attr) > -1
    }

    const showReasonInput = attr => {
      let comment = document.getElementById(`reason-comment-${attr}`)
      let reasonInput = document.getElementById(`reason-input-${attr}`)
      comment.style.display = 'none'
      reasonInput.style.display = 'block'
      reasonInput.focus()
    }
    const addComma = index => {
      return (
        currentReceipt.expenseTypeId &&
        currentReceipt.expenseTypeId.length - 1 !== index &&
        currentReceipt.expenseTypeId.length > 1
      )
    }

    return {
      rejectHeaders,
      currentReceipt,
      prorateCalc,
      rejectedAttrs,
      rejected,
      rejectToggleAttr,
      showReasonInput,
      onBlur,
      isShowImgPreview,
      addComma,
      imgPreviewState,
      ...useDialog(),
      ...useReceiptForm(),
    }
  },
}
</script>

<style lang="scss" scoped>
.rejected-line {
  background: theme('colors.red.lightest');
}
td:first-child {
  border-top-left-radius: 22px;
  border-bottom-left-radius: 22px;
}
td:last-child {
  border-top-right-radius: 22px;
  border-bottom-right-radius: 22px;
}
tr:last-child {
  border: none;
}
</style>
